export const weatherDescriptions = {
    "clear sky": "Ясное небо",
    "few clouds": "Немного облачно",
    "scattered clouds": "Рассеянные облака",
    "broken clouds": "Прерывистые облака",
    "overcast clouds": "Пасмурные облака",
    "light rain": "Небольшой дождь",
    "moderate rain": "Умеренный дождь",
    "heavy intensity rain": "Сильный дождь",
    "very heavy rain": "Очень сильный дождь",
    "extreme rain": "Экстремальный дождь",
    "light shower snow": "Легкий дождь со снегом",
    "light snow": "Небольшой снег",
    "snow": "Снег",
    "heavy snow": "Сильный снег",
    "sleet": "Мокрый снег",
    "shower rain": "Ливень",
    "heavy intensity shower rain": "Ливень с сильным дождем",
    "ragged shower rain": "Прерывистый ливень",
    "thunderstorm with light rain": "Гроза с небольшим дождем",
    "thunderstorm with rain": "Гроза с дождем",
    "thunderstorm with heavy rain": "Гроза с сильным дождем",
    "light thunderstorm": "Легкая гроза",
    "thunderstorm": "Гроза",
    "heavy thunderstorm": "Сильная гроза",
    "ragged thunderstorm": "Прерывистая гроза",
    "mist": "Дымка",
    "smoke": "Дым",
    "haze": "Мгла",
    "fog": "Туман",
    "sand/ dust whirls": "Песчаные/пыльные вихри",
    "sand": "Песок",
    "dust": "Пыль",
    "volcanic ash": "Вулканический пепел",
    "squalls": "Шквалы",
    "tornado": "Торнадо",
    "light intensity drizzle": "Слабая морось",
    "drizzle": "Морось",
    "heavy intensity drizzle": "Сильная морось",
    "light intensity drizzle rain": "Слабый моросящий дождь",
    "drizzle rain": "Моросящий дождь",
    "heavy intensity drizzle rain": "Сильный моросящий дождь",
    "shower rain and drizzle": "Ливень с дождем и моросью",
    "heavy shower rain and drizzle": "Сильный ливень с дождем и моросью",
    "shower drizzle": "Ливневая морось",
};
  